const PRIORITY_KEYS = ['detail', 'message', 'errors', 'non_field_errors'];

const collectMessages = (value, seen = new Set()) => {
  if (value === null || value === undefined || value === false) return [];
  if (typeof value === 'string' || typeof value === 'number') {
    const text = String(value).trim();
    return text ? [text] : [];
  }
  if (Array.isArray(value)) {
    return value.flatMap((item) => collectMessages(item, seen));
  }
  if (value instanceof Error) {
    return value.message ? [value.message] : [];
  }
  if (typeof value !== 'object' || seen.has(value)) return [];

  seen.add(value);
  const messages = [];
  PRIORITY_KEYS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      messages.push(...collectMessages(value[key], seen));
    }
  });
  Object.entries(value).forEach(([key, nested]) => {
    if (PRIORITY_KEYS.includes(key) || key === 'error_id') return;
    messages.push(...collectMessages(nested, seen));
  });
  return messages;
};

export const extractApiError = (error, fallback = 'Ocurrió un error') => {
  const payload = error?.response?.data ?? error;
  const messages = collectMessages(payload);
  const unique = [...new Set(messages)];
  if (unique.length > 0) return unique.join(' ');

  const errorId = payload?.error_id;
  return errorId ? `${fallback} (ID: ${errorId})` : fallback;
};

export default extractApiError;
